// Actions
export const ADD_ITEM = 'companyExperience/entities/accountManagers/ADD_ITEM'

// Action Creators
export const addItem = (id, item) => ({
  type: ADD_ITEM,
  meta: { id },
  payload: item,
})

// Reducers
const defaultEntity = {}

const entity = (state = defaultEntity, { type, payload }) => {
  switch (type) {
    case ADD_ITEM:
      return { ...state, ...payload }

    default:
      return state
  }
}

const defaultMap = {}

const map = (state = defaultMap, { type, meta, payload }) => {
  switch (type) {
    case ADD_ITEM:
      return {
        ...state,
        [meta.id]: entity(state[meta.id], { type, payload }),
      }

    default:
      return state
  }
}

export default map

export const getAccountManagerMap = state => state.entities.accountManagers || defaultMap
export const getAccountManagerItem = (state, id) => state.entities.accountManagers[id] || defaultEntity
